import React from "react";

export const NotFound = () => <h1>Page Not Found</h1>;
